"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssociatedImagesResponseSchema = void 0;
const image_association_types_1 = require("../models/image_association_types");
exports.AssociatedImagesResponseSchema = image_association_types_1.ImageSchema.array();
//# sourceMappingURL=image_associations.js.map